import React from "react";
import {ServiceBase} from "../service-base";
import {
    IAppVersionUpdateSuggestionDialogOptions,
    IBoardingPassesDialogOptions,
    IBundleUpgradeSuggestionDialogOptions, IChangePasswordDialogOptions,
    IDialogFactoryService,
    IEditCompanionDialogOptions,
    IEditPersonTravelDocumentDialogOptions,
    ILoginAndRegistrationDialogOptions,
    IMultipleSsrsSelectorDialogOptions,
    IOnlineCheckInValidationDialogOptions,
    IPasswordResetDialogOptions,
    IPriorityBoardingSuggestionDialogOptions,
    ISeatDescriptionDialog,
    IShowRegistrationInstructionsDialogOptions,
    ISimpleMessageDialogOptions,
    ISsrsSelectionDialogOptions,
    IYesNoDialogOptions,
    OnlineCheckInValidationResultEnum
} from "./dialog-factory.service.interface";
import {DialogCloseButtonBehavior, DialogResult} from "../dialog/dialog-enums";
import {BoardingPassDialogComponent} from "../../pages/check-in-flow/boarding-passes/boarding-pass-dialog.component";
import {
    PriorityBoardingSuggestionChoice,
    PriorityBoardingSuggestionDialogComponent
} from "../../pages/booking-flow/bags-selection/components/priority-boarding-suggestion-dialog.component";
import {IBundleViewModel} from "../booking/models/bundle/bundle-view-model.interface";
import {
    BundleUpgradeSuggestionDialogComponent
} from "../../pages/booking-flow/fare-selection/components/bundle/bundle-upgrade-suggestion-dialog.component";
import {
    OnlineCheckInValidationDialogComponent
} from "../../pages/check-in-flow/passengers/components/online-check-in-validation-dialog.component";
import {
    InvalidPromoCodeDialogComponent
} from "../../components/promotionals/promo-code/invalid-promo-code-dialog.component";
import {
    AppVersionUpdateSuggestionDialogComponent
} from "../../components/app-version-update-suggestion-dialog/app-version-update-suggestion-dialog.component";
import {LoginAndRegistrationDialogComponent} from "../../components/login/login-and-registration-dialog.component";
import {ILoginResponse} from "../airline-webapi/responses/login.response";
import {
    RegistrationInstructionsDialogComponent
} from "../../components/login/registration-instructions-dialog.component";
import {
    TermsAndConditionsDialogComponent
} from "../../components/terms-and-conditions/terms-and-conditions-dialog.component";
import {
    B2CUserContactInformationEditorDialogComponent
} from "../../pages/user/user-profile/components/b2c-user-contact-information-editor-dialog.component";
import {ConfirmRegistrationDialogComponent} from "../../components/login/confirm-registration-dialog.component";
import {ResetPasswordDialogComponent} from "../../components/login/reset-password-dialog.component";
import {IPasswordResetFormFields} from "../user/models/password-reset/password-reset-form-fields.interface";
import {IUserProfileEditorViewModel} from "../user/models/profile/user-profile-editor-view-model.interface";
import {CompanionEditorDialogComponent} from "../../pages/companions/components/companion-editor-dialog.component";
import {
    PersonTravelDocumentEditorDialogComponent
} from "../../components/person/person-travel-document-editor-dialog.component";
import {YesNoDialogResult} from "./yes-no-dialog.enums";
import {YesNoDialogComponent} from "../../components/common-dialogs/yes-no-dialog.component";
import {
    InvalidBlueBenefitsSubscriptionDialogComponent
} from "../../pages/booking-flow/blue-benefits-purchase/components/invalid-blue-benefits-subscription-dialog.component";
import {
    SsrsSelectionDialogComponent
} from "../../pages/booking-flow/common-components/ssrs/ssrs-selection-dialog.component";
import {
    SeatMapGroupDetailsDialogComponent
} from "../../pages/booking-flow/seat-selection/dialogs/seat-map-group-details-dialog.component";
import {SimpleMessageDialogComponent} from "../../components/common-dialogs/simple-message-dialog.component";
import {
    SeatSelectionDialogComponent
} from "../../pages/booking-flow/seat-selection/dialogs/seat-selection-dialog.component";
import {ChangeSearchDialogComponent} from "../../pages/booking-flow/change-search/change-search-dialog.component";
import {
    AgencyContactInformationEditorDialogComponent
} from "../../pages/agency/profile/components/contact-information/agency-contact-information-editor-dialog.component";
import {NullableString} from "../../types/nullable-types";
import {ChangeExpiredPasswordDialogComponent} from "../../components/login/change-expired-password-dialog.component";
import {
    AgencyChangePasswordEditorDialogComponent
} from "../../pages/agency/profile/components/change-password/agency-change-password-editor-dialog.component";




export class DialogFactoryService extends ServiceBase implements IDialogFactoryService {
    async showBoardingPasses(options: IBoardingPassesDialogOptions): Promise<DialogResult> {
        let boardingPasses =  options.boardingPasses;
        /*
        boardingPasses = [
            ...boardingPasses,
            ...boardingPasses,
            ...boardingPasses,
        ]
         */
        return await this.services.dialog.showStandardDialog({
            width: boardingPasses.length === 1 ? "450px" : "880px",
            render: (modalHandler) => <BoardingPassDialogComponent dialogHandler={modalHandler}
                                                                   bookingKey={options.bookingKey}
                                                                   boardingPasses={boardingPasses}/>
        });
    }

    async showPriorityBoardingSuggestion(options: IPriorityBoardingSuggestionDialogOptions): Promise<DialogResult> {
        return await this.services.dialog.showPopupDialog<PriorityBoardingSuggestionChoice>({
            render: (modalHandler) => (<PriorityBoardingSuggestionDialogComponent dialogHandler={modalHandler}/>),
            onAccept: async (choice) => {
                await options.onAccept(choice);
            }
        });
    }


    async showBundleUpgradeSuggestion(options: IBundleUpgradeSuggestionDialogOptions): Promise<void> {

        await this.services.dialog.showStandardDialog<IBundleViewModel>({
            closeButtonBehavior: DialogCloseButtonBehavior.Reject,
            render: (modalHandler => <BundleUpgradeSuggestionDialogComponent dialogHandler={modalHandler}
                                                                             upgradeFrom={options.upgradeFrom}
                                                                             upgradeTo={options.upgradeTo}
                                                                             benefits={options.benefits}/>),
            onAccept: async (selectedBundle) => {
                await options.onAccept(selectedBundle);
            }
        });
    }

    async showChangePassword(options: IChangePasswordDialogOptions): Promise<void> {

        await this.services.dialog.showStandardDialog<ILoginResponse>({
            closeButtonBehavior: DialogCloseButtonBehavior.Reject,
            width: "420px",
            render:dialogHandler => (<AgencyChangePasswordEditorDialogComponent dialogHandler={dialogHandler}
                                                                                changePasswordEditor={options.form} />),
            onAccept: async (changePasswordResult: ILoginResponse | undefined) => {
                await options.onResolved(changePasswordResult ?? null);
            },
            onReject: async () => {
                await options.onResolved(null);
            }
        });
    }

    async showOnlineCheckInValidation(options: IOnlineCheckInValidationDialogOptions): Promise<void> {
        await this.services.dialog.showStandardDialog<OnlineCheckInValidationResultEnum>({
            render: (dialogHandler) => (<OnlineCheckInValidationDialogComponent dialogHandler={dialogHandler}/>),
            onAccept: async (result: OnlineCheckInValidationResultEnum | undefined) => {
                await options.onAccept(result);
            }
        });
    }

    async showInvalidPromotionCode(): Promise<DialogResult> {
        return await this.services.dialog.showPopupDialog({
            closeButtonBehavior: DialogCloseButtonBehavior.Reject,
            width: "470px",
            render: (modalHandler) => <InvalidPromoCodeDialogComponent dialogHandler={modalHandler} />
        });
    }

    async showAppVersionUpdateSuggestion(options: IAppVersionUpdateSuggestionDialogOptions): Promise<void> {
        await this.services.dialog.showPopupDialog({
            render: (dialogHandler) => <AppVersionUpdateSuggestionDialogComponent dialogHandler={dialogHandler}
                                                                                  appVersionBlockingMode={options.appVersionUpgradeMode}/>
        });
    }

    async showLoginAndRegistration(options: ILoginAndRegistrationDialogOptions): Promise<void> {
        await this.services.dialog.showStandardDialog<ILoginResponse>({
            render:dialogHandler => (<LoginAndRegistrationDialogComponent dialogHandler={dialogHandler}
                                                                          tab={options.defaultTab}
                                                                          hideRegistrationTab={options.hideRegistrationTab}
                                                                          loginAndRegistrationHandler={options.loginAndRegistrationHandler}/>)
        });
    }

    async showB2CAuthorizedUserContactInformationEditor(profileEditor: IUserProfileEditorViewModel): Promise<DialogResult> {
        return await this.services.dialog.showStandardDialog({
            render:dialogHandler => (<B2CUserContactInformationEditorDialogComponent dialogHandler={dialogHandler}
                                                                                     userProfileEditor={profileEditor}/>)
        });
    }

    async showAgencyContactInformationEditor(profileEditor: IUserProfileEditorViewModel): Promise<DialogResult> {
        return await this.services.dialog.showStandardDialog({
            closeButtonBehavior: DialogCloseButtonBehavior.Reject,
            maxHeight: "98%",
            render:dialogHandler => (<AgencyContactInformationEditorDialogComponent dialogHandler={dialogHandler}
                                                                                    userProfileEditor={profileEditor}/>)
        });
    }

    async showRegistrationInstructions(options: IShowRegistrationInstructionsDialogOptions): Promise<void> {
        await this.services.dialog.showPopupDialog({
            render: dialogHandler => {
                options.captureDialogHandler(dialogHandler);
                return (<RegistrationInstructionsDialogComponent dialogHandler={dialogHandler} />)
            }
        })
    }

    async showCookiesPolicy(): Promise<void> {
        await this.services.dialog.showStandardDialog({
            render: dialogHandler => <TermsAndConditionsDialogComponent dialogHandler={dialogHandler}/>
        });
    }

    async showRegistrationConfirmation(): Promise<void> {
        await this.services.dialog.showPopupDialog({
            render: dialogHandler => (<ConfirmRegistrationDialogComponent dialogHandler={dialogHandler}/>)
        });
    }

    async showPasswordReset(options: IPasswordResetDialogOptions): Promise<void> {
        await this.services.dialog.showStandardDialog<IPasswordResetFormFields>({
            render: dialogHandler => (<ResetPasswordDialogComponent dialogHandler={dialogHandler} form={options.form}/>),
        })
    }

    async showCompanionEditor(options: IEditCompanionDialogOptions): Promise<DialogResult> {
        return await this.services.dialog.showStandardDialog({
            render: dialogHandler => (<CompanionEditorDialogComponent dialogHandler={dialogHandler} companion={options.companion}/>)
        });
    }

    async showPersonTravelDocumentEditor(options: IEditPersonTravelDocumentDialogOptions): Promise<DialogResult> {
        return await this.services.dialog.showStandardDialog({
            render: dialogHandler => (<PersonTravelDocumentEditorDialogComponent dialogHandler={dialogHandler} travelDocument={options.travelDocument}/>)
        });
    }

    async showYesNoDialog(options: IYesNoDialogOptions): Promise<YesNoDialogResult> {
        const dialogResult = await this.services.dialog.showPopupDialog({
            maxHeight: '480px',
            width: '416px',
            render: dialogHandler => (<YesNoDialogComponent dialogHandler={dialogHandler} {...options}/>)
        });
        if(dialogResult === DialogResult.Accepted) {
            return YesNoDialogResult.Yes;
        }
        return YesNoDialogResult.No;
    }

    async showInvalidBlueBenefitsSubscription(): Promise<void> {
        await this.services.dialog.showPopupDialog({
            render: (modalHandler) => <InvalidBlueBenefitsSubscriptionDialogComponent dialogHandler={modalHandler}/>
        });
    }

    async showMultipleSsrsSelector(options: IMultipleSsrsSelectorDialogOptions): Promise<DialogResult> {
        return await this.services.dialog.showStandardDialog({
            closeButtonBehavior: options.backButtonBehavior ?? DialogCloseButtonBehavior.Accept,
            render: dialogHandler => (
                <SsrsSelectionDialogComponent renderTitle={() => options.title}
                                              renderSubtitle={() => null}
                                              dialogHandler={dialogHandler}
                                              ssrsAggregator={options.aggregator}/>
            )
        });
    }

    async showSsrsSelector(options: ISsrsSelectionDialogOptions): Promise<DialogResult> {
        let {closeButtonBehavior, ...dialogProps} = options;

        return await this.services.dialog.showStandardDialog({
            closeButtonBehavior: closeButtonBehavior ?? DialogCloseButtonBehavior.Accept,
            dismissOnEscapeKey: true,
            render: dialogHandler => (
                <SsrsSelectionDialogComponent dialogHandler={dialogHandler} {...dialogProps}/>
            ),
            onAccept: options.onAccept
        });
    }

    async showSeatDescriptionDialog(options: ISeatDescriptionDialog): Promise<DialogResult> {
        return await this.services.dialog.showSheetModalDialog({
            closeButtonBehavior: DialogCloseButtonBehavior.Accept,
            render: dialogHandler => (
                <SeatMapGroupDetailsDialogComponent seatsRowGroupType={options.groupType}
                                                    dialogHandler={dialogHandler}/>
            )
        });
    }

    async showSimpleMessageDialog(options: ISimpleMessageDialogOptions): Promise<void> {
        await this.services.dialog.showPopupDialog({
            closeButtonBehavior: options.closeButtonBehavior ?? DialogCloseButtonBehavior.Accept,
            render: dialogHandler => (
                <SimpleMessageDialogComponent title={options.title} message={options.message} buttonText={options.buttonText} dialogHandler={dialogHandler}/>
            )
        });
    }

    async showSeatsSelection(): Promise<void> {
        await this.services.dialog.showStandardDialog({
            closeButtonBehavior: DialogCloseButtonBehavior.Accept,
            forceFullScreenOnLargeScreens: true,
            render: dialogHandler => (<SeatSelectionDialogComponent dialogHandler={dialogHandler} />)
        });
    }

    async showChangeFlightSearch(): Promise<void> {
        await this.services.dialog.showPopupDialog({
            closeButtonBehavior: DialogCloseButtonBehavior.Reject,
            width: "380px",
            render: dialogHandler => (<ChangeSearchDialogComponent dialogHandler={dialogHandler}/>)
        })
    }

    showChangeExpiredPassword(): Promise<NullableString> {
        return new Promise<NullableString>(async (resolve) => {
            await this.services.dialog.showPopupDialog<string>({
                closeButtonBehavior: DialogCloseButtonBehavior.Reject,
                width: "470px",
                render: dialogHandler => (<ChangeExpiredPasswordDialogComponent dialogHandler={dialogHandler}/>),
                onAccept: async (newPassword) => {
                    resolve(newPassword ?? null);
                },
                onReject: async () => {
                    resolve(null);
                }
            })
        })
    }
}
